import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import "../styles/notFound.css";

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <Navbar />

      <main className="not-found-section">
        <div className="not-found-divider" />
        <div className="not-found-glow" />

        <div className="container not-found-shell">
          <p className="not-found-eyebrow ff_n">Page Not Found</p>
          <h1 className="not-found-code ff_s">404</h1>
          <h2 className="not-found-title ff_s">
            This route went off script.
          </h2>
          <p className="not-found-text ff_n">
            The page you are looking for may have been moved, renamed, or is no
            longer available.
          </p>

          <div className="not-found-actions">
            <Link to="/" className="not-found-primary ff_n">
              Back to Home
            </Link>
            <Link to="/blogs" className="not-found-secondary ff_n">
              View Blogs
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotFoundPage;
